import type { EntryKind, Runtime } from "@schema/catalog.ts";
import styles from "./RuntimeChip.module.css";

export function formatMinutes(minutes: number): string {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
}

export function RuntimeChip({ runtime, kind }: { runtime: Runtime; kind: EntryKind }) {
  // The cheapest curated route, and the route itself — not every shortcut is an
  // essential-episodes list, so the tooltip names the one curation actually
  // wrote rather than assuming.
  const route = runtime.alternatives.reduce<Runtime["alternatives"][number] | null>(
    (best, alt) =>
      alt.minutes < runtime.minutes && (!best || alt.minutes < best.minutes) ? alt : best,
    null,
  );
  const shortest = route ? route.minutes : runtime.minutes;
  const hasShortcut = route !== null;
  return (
    <span
      className={styles.chip}
      title={
        route
          ? `Full ${kind === "season" ? "season" : "runtime"}: ${formatMinutes(runtime.minutes)}, compressible to ${formatMinutes(shortest)}. ${route.label}.`
          : undefined
      }
    >
      {kind === "season" && <span className={styles.kind}>Series</span>}
      {formatMinutes(runtime.minutes)}
      {hasShortcut && <span className={styles.alt}>▾ {formatMinutes(shortest)}</span>}
    </span>
  );
}
